var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", [_vm._v(_vm._s(_vm.$t("Registration.SuomiFi.Description")))]),
    _vm._v(" "),
    _vm.suomiFiRequest != ""
      ? _c(
          "form",
          {
            attrs: {
              method: "post",
              name: "suomiFiForm",
              action: _vm.suomiFiUri
            }
          },
          [
            _c("input", {
              attrs: { type: "hidden", name: "SAMLRequest" },
              domProps: { value: _vm.suomiFiRequest }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "RelayState", value: "" }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary login-page-button",
                attrs: { type: "submit" }
              },
              [_vm._v(_vm._s(_vm.$t("Registration.SuomiFi.Button")))]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }